import { motion } from "framer-motion";

import { content } from "../../content/content";
import { fadeUp, staggerContainer } from "../../hooks/useScrollReveal";
import { Flourish } from "../Flourish";

export function Trust() {
  return (
    <section
      id="trust"
      className="relative overflow-hidden bg-warm-cream/65 py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          className="mb-16 max-w-2xl"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p
            data-edit-id="content.trust.eyebrow"
            className="mb-4 inline-flex items-center gap-3 font-body text-xs font-medium tracking-[0.22em] text-violet uppercase"
          >
            <Flourish className="h-4 w-4 text-violet/70" />
            {content.trust.eyebrow}
          </p>
          <h2
            data-edit-id="content.trust.headline"
            className="text-balance font-display text-[clamp(2rem,4vw,3.5rem)] text-ink"
          >
            {content.trust.headline}
          </h2>
          <p
            data-edit-id="content.trust.intro"
            className="mt-4 font-body text-lg text-ink-muted"
          >
            {content.trust.intro}
          </p>
        </motion.div>

        <motion.div
          className="mt-12 grid gap-6 md:grid-cols-3 md:gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {content.trust.pillars.map((pillar) => (
            <motion.div
              key={pillar.id}
              data-edit-id={`content.trust.pillars[${pillar.id}]`}
              className="flex flex-col gap-4 rounded-2xl border border-ink/10 bg-warm-white/85 p-7 md:p-8"
              variants={fadeUp}
            >
              <p
                data-edit-id={`content.trust.pillars[${pillar.id}].label`}
                className="font-body text-[11px] font-medium tracking-[0.22em] text-saffron-dark uppercase"
              >
                {pillar.label}
              </p>
              <p
                data-edit-id={`content.trust.pillars[${pillar.id}].body`}
                className="font-body text-base leading-relaxed text-ink-light"
              >
                {pillar.body}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="mt-16 flex flex-col items-start gap-6 rounded-2xl bg-ink p-8 text-warm-white md:mt-20 md:flex-row md:items-center md:justify-between md:gap-12 md:p-12"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <div>
            <p
              data-edit-id="content.trust.ctaEyebrow"
              className="mb-3 font-body text-[11px] font-medium tracking-[0.22em] text-saffron-light uppercase"
            >
              {content.trust.ctaEyebrow}
            </p>
            <h3
              data-edit-id="content.trust.ctaHeadline"
              className="font-display text-[clamp(1.4rem,2.4vw,2rem)] leading-[1.2]"
            >
              {content.trust.ctaHeadline}
            </h3>
            <p
              data-edit-id="content.trust.ctaBody"
              className="mt-3 max-w-xl font-body text-sm leading-relaxed text-warm-white/75 md:text-base"
            >
              {content.trust.ctaBody}
            </p>
          </div>
          <a
            data-edit-id="content.trust.ctaButton"
            href={content.trust.ctaMailto}
            className="shrink-0 rounded-2xl bg-saffron px-7 py-3.5 font-body text-sm font-medium text-warm-white transition-colors duration-300 hover:bg-saffron-dark"
          >
            {content.trust.ctaButton}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
